// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","emptyFeed":"D8aDq","productCard":"_3JrHe","relatedProductsArea":"_1Mm2A _1bL04 _2_DZ4 _30NYb eybWJ _1i_4K"};